import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Button,
  ButtonGroup,
  Heading,
  Modal,
  NegativeNotice,
  Radio,
  RadioGroup,
  RadioLabel,
  RadioControl,
} from 'next/components/ui';

const DescriptionWrapper = styled.div`
  margin-top: 12px;

  label {
    padding: 12px 6px !important;
  }
`;
const Label = styled.div`
  font-weight: var(--bold) !important;
`;

const LabelDescription = styled.div`
  padding-top: 6px;
  color: var(--sharkbait-ooh-la-la);
`;

const ButtonsWrapper = styled(ButtonGroup)`
  margin-top: 24px;
`;

export const InvitePermissionModal = ({
  discoverable,
  visible,
  error = false,
  onSave,
  onClose,
}) => {
  const [value, setValue] = useState(
    discoverable ? 'discoverable' : 'invitation'
  );

  const handleSave = () => {
    onSave(value === 'discoverable');
  };

  return (
    <Modal onClose={onClose} size="m" visible={visible}>
      <Heading>Invite permissions</Heading>

      {error && (
        <NegativeNotice>
          We&apos;re sorry, something went wrong on our end. Try again.
        </NegativeNotice>
      )}

      <DescriptionWrapper>
        <RadioGroup name="permissions" onValueChange={setValue} value={value}>
          <RadioControl>
            <Radio id="invitation" value="invitation" />
            <RadioLabel htmlFor="invitation">
              <Label>Invitation Only</Label>
              <LabelDescription>
                New users must be invited to this account.
              </LabelDescription>
            </RadioLabel>
          </RadioControl>
          <RadioControl>
            <Radio id="discoverable" value="discoverable" />
            <RadioLabel htmlFor="discoverable">
              <Label>Discoverable for anyone with a matching domain</Label>
              <LabelDescription>
                Users with email addresses that match your domain can discover
                this account and join.
              </LabelDescription>
            </RadioLabel>
          </RadioControl>
        </RadioGroup>
      </DescriptionWrapper>

      <ButtonsWrapper right>
        <Button kind="primary" onClick={handleSave}>
          Save
        </Button>
        <Button kind="secondary" onClick={onClose}>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Modal>
  );
};
InvitePermissionModal.propTypes = {
  discoverable: PropTypes.bool,
  visible: PropTypes.bool,
  error: PropTypes.bool,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

export default InvitePermissionModal;
